<template>
  <div style="overflow: hidden;">
    <div
      style="width:100%;height:200vw;background-color:white;position: absolute;z-index: -1;"
    ></div>
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div v-if="!hideHeader" class="navbar w-100" style="background-color: #23409a; color: white;">
      <h3 class="w-100 text-center my-3">ความยินยอม</h3>
    </div>
    <div v-else style="width: 100%;height: 67px;"></div>
    <div
      v-if="!loading"
      class="w-100"
      style="height: calc(100vh - 67px); overflow: auto;background-color:white;padding-bottom:67px"
    >
      <div id="gray-body" class="bg-gray p-3 p-sm-4">
        <div v-if="mktHtmlData && mktHtmlData.htmlBody" v-html="mktHtmlData.htmlBody"></div>

        <div class="flex-center">
          <v-radio-group v-model="pdpa_mkt" :row="true">
            <v-radio style="padding-right: 20vw" label="ยินยอม" value="Y"></v-radio>
            <v-radio label="ไม่ยินยอม" value="N"></v-radio>
          </v-radio-group>
        </div>

        <div
          v-if="mktPdpaHtmlData && mktPdpaHtmlData.htmlBody"
          v-html="mktPdpaHtmlData.htmlBody"
        ></div>

        <div class="flex-center">
          <v-radio-group v-model="pdpa_mktpdpa" :row="true">
            <v-radio style="padding-right: 20vw" label="ยินยอม" value="Y"></v-radio>
            <v-radio label="ไม่ยินยอม" value="N"></v-radio>
          </v-radio-group>
        </div>
        <div
          v-if="mktRemarkHtmlData && mktRemarkHtmlData.htmlBody"
          v-html="mktRemarkHtmlData.htmlBody"
        ></div>
      </div>
    </div>
    <div class="w-100 bot-regis flex-all-center">
      <v-btn
        @click="summit"
        :disabled="
          pdpa_mkt == null || pdpa_mktpdpa == null || (pdpa_mkt === mkt && pdpa_mktpdpa === mktPdpa)
        "
        class="col-8 main-btn"
        style="color: white"
        color="#23409A"
        >บันทึก</v-btn
      >
    </div>
  </div>
</template>

<script>
import consendApi from '@/api/consend'
import config from '@/config'
import VueElementLoading from 'vue-element-loading'
import { mapGetters } from 'vuex'

export default {
  props: {
    mkt: {
      default: null
    },
    mktPdpa: {
      default: null
    },
    fetchApi: {
      default: true
    },
    hideHeader: {
      default: false
    }
  },
  components: { VueElementLoading },
  data() {
    return {
      loading: false,
      checkbox: false,
      pdpa_mkt: null,
      pdpa_mktpdpa: null,
      mktHtmlData: null,
      mktPdpaHtmlData: null,
      mktRemarkHtmlData: null
    }
  },
  async mounted() {
    this.pdpa_mkt = this.mkt
    this.pdpa_mktpdpa = this.mktPdpa
    const configApiMkt = {
      params: {
        company: 'NCAP',
        product: 'HP-MC',
        template_id: 'Consent_PDPA_MKT',
        page_id: config.pageid
      }
    }
    const configApiMktPdpa = {
      params: {
        company: 'NCAP',
        product: 'HP-MC',
        template_id: 'Consent_PDPA_MKTPDPA',
        page_id: config.pageid
      }
    }
    const configApiMktRemark = {
      params: {
        company: 'NCAP',
        product: 'HP-MC',
        template_id: 'Consent_PDPA_MKTREMARK',
        page_id: config.pageid
      }
    }
    try {
      this.loading = true

      // const responseMkt = consendApi.getConsendTemplateV2(configApiMkt)
      // const responseMktPdpa = consendApi.getConsendTemplateV2(configApiMktPdpa)
      // const responseMktRemark = consendApi.getConsendTemplateV2(configApiMktRemark)
      // const response = await Promise.all([responseMkt, responseMktPdpa, responseMktRemark])
      // this.mktHtmlData = response[0].data.data
      // this.mktPdpaHtmlData = response[1].data.data
      // this.mktRemarkHtmlData = response[2].data.data

      const responseMkt = await consendApi.getConsendTemplateV2(configApiMkt)
      const responseMktPdpa = await consendApi.getConsendTemplateV2(configApiMktPdpa)
      const responseMktRemark = await consendApi.getConsendTemplateV2(configApiMktRemark)
      this.mktHtmlData = responseMkt.data.data
      this.mktPdpaHtmlData = responseMktPdpa.data.data
      this.mktRemarkHtmlData = responseMktRemark.data.data
    } catch (error) {
      console.error(error)
      this.$swal.fire({
        type: 'error',
        text: 'โหลดข้อมูลไม่สำเร็จ'
      })
    } finally {
      this.loading = false
    }
  },
  methods: {
    async summit() {
      // TODO : do somthing

      if (
        !this.mktHtmlData ||
        !this.mktHtmlData.version ||
        !this.mktPdpaHtmlData ||
        !this.mktPdpaHtmlData.version
      ) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาดไม่พบ version pdpa'
        })
        return
      }
      if (!this.profile || !this.profile.displayName || !this.profile.userId) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาดไม่พบข้อมูลผู้ใช้'
        })
        return
      }
      if (!this.fetchApi) {
        let tempData = this.regisList
        tempData.version.mkt = this.mktHtmlData.version
        tempData.answer.mkt = this.pdpa_mkt
        tempData.version.mktPdpa = this.mktPdpaHtmlData.version
        tempData.answer.mktPdpa = this.pdpa_mktpdpa
        this.$store.dispatch('setRegisList', tempData)
        this.$emit('next')
        return
      }
      try {
        this.loading = true
        await consendApi.postUserConsendV2({
          body: {
            page_id: config.pageid,
            next_body: [
              {
                ConsentType: 'Consent_PDPA_MKT',
                lineName: this.profile.displayName,
                userId: this.profile.userId,
                version: this.mktHtmlData.version,
                companyKey: 'NCAP',
                ConsentItemId: 'MKT',
                answer: this.pdpa_mkt
              },
              {
                ConsentType: 'Consent_PDPA_MKTPDPA',
                lineName: this.profile.displayName,
                userId: this.profile.userId,
                version: this.mktPdpaHtmlData.version,
                companyKey: 'NCAP',
                ConsentItemId: 'MKTPDPA',
                answer: this.pdpa_mktpdpa
              }
            ]
          },
          config: {}
        })
        this.$emit('next')
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาด'
        })
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters(['regisList']),
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    }
  }
}
</script>

<style lang="scss" scoped>
.v-input--radio-group__input {
  justify-content: space-evenly;
  padding: 10px 0;
}
</style>
